<template>
  <div>
    <a-modal
    width="600px"
      :visible="visible"
      :confirm-loading="confirmLoading"
      @ok="handleOk"
      @cancel="handleCancel"
      :footer="null"
      :closable="true"
    >
    <RegisterForm ref="registerform" @ok="loginok" @clear="clear"></RegisterForm>
    </a-modal>
  </div>
</template>
<script>
import RegisterForm from './moudles/RegisterForm.vue'

export default {
    components: {
  RegisterForm
  },
  data() {
    return {
      visible: false,
      confirmLoading: false,
    };
  },
  methods: {
    showModal() {
      this.visible = true;
    },
    handleOk(e) {
      this.ModalText = 'The modal will be closed after two seconds';
      this.confirmLoading = true;
      setTimeout(() => {
        this.visible = false;
        this.confirmLoading = false;
      }, 2000);

    },
    handleCancel(e) {
      this.visible = false;

    },
    loginok(){
      this.handleCancel()
      this.$emit('ok')
    },
    clear(){
      this.handleCancel()
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/views/login/Register.vue